import { Injectable } from '@angular/core';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { BehaviorSubject, Observable, from, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userSubject = new BehaviorSubject<any>(null);
  user$ = this.userSubject.asObservable();
  private tokenSubject = new BehaviorSubject<string | null>(null);
  token$ = this.tokenSubject.asObservable();
  isAuthenticated$: Observable<boolean>;

  constructor(private auth0: Auth0Service) {
    this.isAuthenticated$ = this.auth0.isAuthenticated$;

    this.auth0.user$.subscribe(user => {
      this.userSubject.next(user);
      // Quando l'utente cambia, recupera un nuovo token
      if (user) {
        this.getAccessTokenSilently().subscribe();
      } else {
        this.tokenSubject.next(null);
      }
    });
  }

  login(): void {
    this.auth0.loginWithRedirect();
  }

  logout(): void {
    this.auth0.logout();
  }

  getCurrentUser$(): Observable<any> {
    return this.auth0.user$;
  }

  getAccessTokenSilently(): Observable<string | null> {
    return this.isAuthenticated$.pipe(
      switchMap(isAuthenticated => {
        if (isAuthenticated) {
          return from(this.auth0.getAccessTokenSilently()).pipe(
            tap(token => {
              this.tokenSubject.next(token);
              localStorage.setItem('auth_token', token);
            }),
            catchError(error => {
              console.error('Errore nel recupero del token:', error);
              return of(null);
            })
          );
        }
        return of(null);
      })
    );
  }

  getToken(): string | null {
    return this.tokenSubject.value || localStorage.getItem('auth_token');
  }
}
